import { render } from "./ResetUserData.vue?vue&type=template&id=17975906&scoped=true"
import script from "./ResetUserData.vue?vue&type=script&lang=js"
export * from "./ResetUserData.vue?vue&type=script&lang=js"

import "./ResetUserData.vue?vue&type=style&index=0&id=17975906&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/cloudstack/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17975906"]])

export default __exports__